import React, { Component } from 'react'

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';

import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Bar } from 'react-chartjs-2';
import Checkbox from '@material-ui/core/Checkbox';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment'
import setting from '../../config/setting'
import { groupBy } from '../SharedComponents/KRIDataGrouping'
import { KRIAlertChartDataFormationMonthly } from '../SharedComponents/KRIAlertChartDataFormation'
import {styles} from '../CSS/Styles';

class DuplicateTxnTable extends Component {

    render() {
        console.log("duplicate transctions data!")
        console.log(this.props.alert);
        const classes = this.props;
        // console.log("Txn props:");
        // console.log(this.props);
        let alert = KRIAlertChartDataFormationMonthly(this.props.data, [this.props.alert], this.props.threshold)
        alert = alert[0]
        console.log(alert)
        let i = 0;
        let k = 0;
        return (
            <div>
                <Typography align='left'>
                    {alert.risk_name == null? null : alert.risk_name}
                </Typography>
                <Typography align='left'>
                    {alert.kri_id == null? null : alert.kri_id + ' -- ' + alert.description}
                </Typography>
                <br/>
                <Bar data={alert.data} height={100} options={{
                    plugins: {
                        datalabels: {
                            display: true,
                            color: 'white',
                            anchor: 'end',
                            align: 'start'
                        }
                    },
                    scales: {
                        yAxes: [{
                            gridLines: {
                                display: false,
                                drawBorder: false
                            },
                            ticks: {
                                beginAtZero: true,
                                display: false
                            }
                        }],
                        xAxes: [
                            {
                                barPercentage: 0.5,
                                gridLines: {
                                    display: false,
                                    drawBorder: true
                                },
                                ticks: {
                                    fontSize: 10
                                }
                            }
                        ]
                    },
                    legend: {display: false}
                }}/>
            </div>
        )
    }
}
export default withStyles(styles)(DuplicateTxnTable)


// WEBPACK FOOTER //
// ./src/components/KRI/KRIAlertDetailTable.js